import _ from '@lodash';
import Checkbox from '@mui/material/Checkbox';
import Icon from '@mui/material/Icon';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { motion } from 'framer-motion';
import { memo, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import JobsTableHead from './JobsTableHeader';
import FuseMessage from '@fuse/core/FuseMessage';
import { showMessage } from 'app/store/fuse/messageSlice';
import { TableContainer } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { connect } from 'react-redux';
import withReducer from 'app/store/withReducer';
import JobAction from 'app/stores/loadz/redux/Jobs/actions';
import AuthAction from 'app/stores/loadz/redux/Auth/actions';
import JobReducer from 'app/stores/loadz/redux/Jobs';
import { LinearProgress } from '@material-ui/core';
import { hasPermission } from 'app/main/loadz/utils';
import ErrorBoundary from 'app/main/ErrorBoundary';
import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
import { Button, Dialog, DialogContent, DialogContentText } from '@mui/material';
import {useTranslation} from 'react-i18next';
import client from 'client';
import { useSubscriptionPaywall } from 'app/main/subscriptionManagement/SubscriptionPaywallContext';
import OriginalJobLabel from 'app/main/loadz/components/OriginalJobLabel';
import { constants } from '../../../../constants';
import lockIcon from './icons/lock.svg';
import editIcon from './icons/edit.svg';
import downIcon from './icons/down.svg';

/** Origin jobs keep the location id in j_origin; quarry jobs keep it in quarry_pit. The list API hydrates quarry_pit with the location object in both cases. */
const getOriginName = (job) => job?.quarry_pit?.l_name || job?.j_origin?.l_name || '-';

const JobsTable = ({
  getJobs,
  searchJobs,
  loading,
  hasNextPage,
  page,
  jobs,
  search,
  ticketText,
  setTicketText,
  reData,
  setReData,
  jobFilter,
  logout,
  user,
  data,
  setJob_id,
  setEditJobOpen,
  setEditJobBillingOpen,
  setTicketTableOpen,
  setJobFilter,
  selected,
  setSelected,
}) => {
  const dispatch = useDispatch();
  const listInnerRef = useRef();
  const history = useHistory();
  const { notifyPastDue } = useSubscriptionPaywall();
  const [order, setOrder] = useState({ direction: 'asc', id: null });
  const [scrollX, setScrollX] = useState(0);
  const [openDelete, setOpenDelete] = useState(false);
  const [deleteDraft, setDeleteDraft] = useState(null);
  const [actionMenu, setActionMenu] = useState(null);
  const [actionJob, setActionJob] = useState(null);
  const {t} = useTranslation('navigation');

  // ✅ OPTIMIZACIÓN: Flags y refs para prevenir scroll duplicado
  const isFetchingRef = useRef(false); // Flag para prevenir llamadas concurrentes
  const scrollDebounceRef = useRef(null); // Timer para debounce

  // var permission = false

  // if (user) {
  //   console.log(user)
  //   if (user.permissions.Jobs != null || user.permissions.Jobs != undefined) {
  //     if (
  //       user.permissions.Jobs.edit == true ||
  //       user.permissions.Jobs.edit == false
  //     ) {
  //       var permission = user.permissions.Jobs.edit
  //     } else {
  //       var permission = true
  //     }
  //   } else {
  //     var permission = true
  //   }
  // }

  function handleDeselect() {
    setSelected([]);
  }

  function handleClick(job) {
    //need in a dialog set open dialog
    data ? complist(job) : history.push(`/jobs/by-id/${job.job_info_id}`);
    return;
  }

  function complist(job) {
    notifyPastDue();
    setJob_id(job.job_info_id);
    setEditJobOpen(true);
  }

  function openTicketPage(job) {
    setTicketTableOpen(true);
    setJob_id(job.job_info_id);
  }

  function handleTicket(job) {
    //need in a dialog set open dialog
    data ? openTicketPage(job) : history.push(`/jobs/ticket/${job.job_info_id}${ticketText.length > 0 ? `/${ticketText}` : ''}`);
    return;
  }

  function selectItem(event, id) {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  }

  const handleSelectAllClick = (event) => {
    event.target.checked ? setSelected(jobs.map((n) => n.job_info_id)) : setSelected([]);
  };

  const handleRequestSort = (event, property) => {
    const id = property;
    let direction = 'desc';
    if (order.id === property && order.direction === 'desc') {
      direction = 'asc';
    }
    setOrder({
      direction,
      id,
    });
  };

  // ✅ OPTIMIZACIÓN: Un solo useEffect para search y jobFilter
  // Evita llamadas duplicadas al montar el componente
  useEffect(() => {
    const fetchData = async () => {
      if (search) {
        // Si hay búsqueda activa, usar searchJobs
        await searchJobs(
          {
            page: 1,
            text: ticketText.length > 0 ? 'ticket_'+search : search,
            search: 'archive',
            compacctnum: data?.compacctnum,
            type: jobFilter,
          },
          (error) => {
            checkAuthError(error);
          }
        );
      } else {
        // Si no hay búsqueda, usar getJobs con filtro
        await getJobs({ page: 1, filter: jobFilter, compacctnum: data?.compacctnum }, (error) => {
          checkAuthError(error);
        });
      }
    };
    
    fetchData();

    // Cleanup: limpiar debounce timer al desmontar
    return () => {
      if (scrollDebounceRef.current) {
        clearTimeout(scrollDebounceRef.current);
      }
    };
  }, [search, jobFilter]); // ← Ambas dependencias en un solo useEffect

  const refreshJobs = async (e) => {
    console.log('refreshing jobs', e);
    await getJobs({ page: 1, filter: jobFilter, compacctnum: data?.compacctnum }, (error) => {
      checkAuthError(error);
    });
  };

  const _showMessage = (msg, color) => {
    dispatch(
      showMessage({
        message: (
          <>
            <Typography>{msg}</Typography>
          </>
        ),
        autoHideDuration: 6000, //ms
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        variant: color,
      })
    );
  };

  const checkAuthError = (error) => {
    if (error?.response?.status == 401) {
      logout();
      history.push('/');
    }
  };

  const onScroll = (event) => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight, scrollLeft, offsetHeight } =
        listInnerRef.current;
      const allow = scrollLeft > scrollX || scrollLeft < scrollX ? false : true;
      setScrollX(scrollLeft);
      
      const scrollDifference = scrollHeight - (offsetHeight + scrollTop);
      
      // ✅ Verificar si estamos cerca del final (umbral de 5px)
      const isNearBottom = (offsetHeight + scrollTop >= scrollHeight || (scrollDifference < 5 && scrollDifference >= 0)) && allow;
      
      if (isNearBottom && !search && hasNextPage) {
        // ✅ OPTIMIZACIÓN 1: Verificar si ya hay una petición en curso
        if (isFetchingRef.current) {
          console.log('⏭️ Scroll pagination already in progress, skipping...');
          return;
        }

        // ✅ OPTIMIZACIÓN 2: Limpiar debounce anterior
        if (scrollDebounceRef.current) {
          clearTimeout(scrollDebounceRef.current);
        }

        // ✅ OPTIMIZACIÓN 3: Debounce de 300ms para evitar múltiples triggers
        scrollDebounceRef.current = setTimeout(async () => {
          // Verificar de nuevo el flag por si cambió durante el debounce
          if (isFetchingRef.current) {
            console.log('⏭️ Request already in progress after debounce, skipping...');
            return;
          }

          try {
            isFetchingRef.current = true; // Marcar como "en progreso"
            console.log('📄 Fetching page:', page + 1);
            
            await getJobs({ 
              page: page + 1, 
              filter: jobFilter, 
              compacctnum: data?.compacctnum 
            });
          } catch (error) {
            console.error('Error fetching next page:', error);
          } finally {
            // Liberar el flag después de 500ms para evitar triggers muy rápidos
            setTimeout(() => {
              isFetchingRef.current = false;
            }, 500);
          }
        }, 300); // Debounce de 300ms
      }
    }
  };

  const closeActionMenu = () => {
    setActionMenu(null);
    setActionJob(null);
  };

  const archiveActionJob = async () => {
    if (!actionJob) {
      return;
    }
    const token = localStorage.token;
    const path = jobFilter === 'archived' ? 'unarchive' : 'archive';
    try {
      const response = await fetch(`${constants.URLLOCAL}/jobs/${path}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          token: `${token}`,
        },
        body: JSON.stringify({ jobsIds: [actionJob.job_info_id] }),
      });
      const res = await response.json();
      if (res.msg) {
        _showMessage(
          jobFilter === 'archived'
            ? `The jobs have been unarchived ${res.jobs}`
            : `The jobs have been archived ${res.jobs}`,
          'success'
        );
        await refreshJobs();
      }
    } catch (error) {
      console.log(error);
      _showMessage('Oh! please try again, something went wrong', 'error');
    }
    closeActionMenu();
  };

  const listTitle = {
    '': t('ALL_JOBS'),
    OG: t('OWNER'),
    sub: t('SUBCONTRACTOR'),
    archived: t('ARCHIVE'),
    commissions: t('COMMISSIONS'),
    drafts: t('DRAFTS'),
    visibility: t('DISABLED'),
  }[jobFilter] || t('ALL_JOBS');

  const handleDeleteDraft = async () => {
    try {
      let result = await client.post('jobs/delete-draft', { jobId: deleteDraft.job_info_id });
      result = result.data;
      if (result?.delete == true) {
        setOpenDelete(false);
        setDeleteDraft(null);
        _showMessage('Draft Deleted', 'success');
        refreshJobs();
      }
    } catch (error) {
      setOpenDelete(false);
      setDeleteDraft(null);
      _showMessage('An Error Occurred', 'error');
      refreshJobs();
    }
  };

  const cardHead = (
    <div className="jobs-redesign-card-head">
      <Typography className="jobs-redesign-card-title">{listTitle}</Typography>
      <Typography className="jobs-redesign-card-count">
        {jobs.length} {t('JOBS_SHOWN_COUNT', { defaultValue: 'jobs shown' })}
      </Typography>
    </div>
  );

  if (jobs.length == 0 && loading == true) {
    return (
      <div className="jobs-redesign-card">
        {cardHead}
        <FuseLoading />
      </div>
    );
  }

  if (jobs.length === 0) {
    return (
      <div className="jobs-redesign-card">
        {cardHead}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { delay: 0.1 } }}
          className="flex flex-1 items-center justify-center h-full moble-content jobs-empty"
        >
          <Typography
            color="textSecondary"
            variant="h5"
          >
            There are no jobs, please create one!
          </Typography>
        </motion.div>
      </div>
    );
  }
  return (
    <>
      <div className="jobs-redesign-card responsive-loads-table">
        {cardHead}
        <FuseMessage />
        <TableContainer
          style={{ maxWidth: '100%', maxHeight: 'calc(90vh - 280px)' }}
          onScroll={onScroll}
          ref={listInnerRef}
        >
          <Table
            stickyHeader
            size="small"
            aria-labelledby="tableTitle"
            className="pb-32"
          >
            <JobsTableHead
              setJobFilter={setJobFilter}
              jobFilter={jobFilter}
              refreshJobs={refreshJobs}
              selectedJobs={selected}
              order={order}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={jobs.length}
              onMenuItemClick={handleDeselect}
              _showMessage={_showMessage}
              setReData={setReData}
            />
            <TableBody>
              {_.orderBy(
                jobs,
                [
                  (o) => {
                    switch (order.id) {
                      case 'unitTemp': {
                        return o.unitTemp[0];
                      }
                      case 'origin':
                        return getOriginName(o);
                      case 'destination':
                        return o?.j_destination?.l_name;
                      case 'material':
                        return o?.job_billing?.name;
                      case 'ticketcompleted':
                        return o?.ticketcompleted;
                      case 'Last_Activity':
                        return o?.recent_tk;
                      case 'ticketqty':
                        return o?.ticketCounts;
                      default: {
                        return o[order.id];
                      }
                    }
                  },
                ],
                [order.direction]
              ).map((n, index) => {
                const isSelected = selected.indexOf(n.job_info_id) !== -1;
                return (
                  <ErrorBoundary>
                    <TableRow
                      className="h-72 cursor-pointer"
                      hover
                      role="checkbox"
                      aria-checked={isSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isSelected}
                    >
                      <TableCell
                        className="w-40 md:w-64 text-center"
                        padding="none"
                      >
                        {n.visibility && (
                          <Checkbox
                            checked={isSelected}
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                            onChange={(event) => selectItem(event, n.job_info_id)}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-16 truncate"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('JOB_NO')}
                      >
                        <span className="jobs-job-no">
                          {n.company_id}-{n.job_no}
                        </span>
                        <OriginalJobLabel job={n} />
                      </TableCell>
                      <TableCell
                        className="p-3 md:p-12"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('CUSTOMER')}
                      >
                        {n.customer_name}
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-16"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('ORIGIN')}
                      >
                        {getOriginName(n)}
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-16"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('DESTINATION')}
                      >
                        {n.j_destination ? n.j_destination.l_name : '-'}
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-16"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('MATERIAL')}
                      >
                        {n.job_billing ? n.job_billing.name : '-'}
                      </TableCell>
                      <TableCell
                        onClick={(event) => handleTicket(n)}
                        sx={{ minWidth: 120 }}
                        className="p-4 md:p-16"
                        data-headtext={t('QUANTITY')}
                      >
                        {n.ticketcompleted ? Number(n.ticketcompleted).toFixed(1) : '-'}
                        {n?.job_billing?.unit_name ? ` ${n.job_billing.unit_name}` : ''}
                      </TableCell>
                      {/* <TableCell className="p-4 md:p-16" component="th" scope="row" onClick={(event) => handleTicket(n)} data-headtext=" Unit">
                            <b>{n.job_billing ? n.job_billing.unit_name : "-"}</b>
                          </TableCell> */}
                      <TableCell
                        className="p-4 md:p-16"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('COMPLETED_TICKETS')}
                      >
                        <span className="jobs-ticket-link">{n?.ticketCounts ? n.ticketCounts : '-'}</span>
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-16"
                        onClick={(event) => handleTicket(n)}
                        data-headtext={t('LAST_ACTIVITY')}
                      >
                        {!n.recent_tk || n.recent_tk == 0 ? (
                          t('NO_RECENT_ACTIVITY')
                        ) : (
                          <span className="jobs-activity">
                            <span>{moment(n.recent_tk).format('MMM D, YYYY')}</span>
                            <span>{moment(n.recent_tk).format('h:mm A')}</span>
                          </span>
                        )}
                      </TableCell>
                     {/*  <TableCell
                        className="p-4 md:p-16"
                        component="th"
                        scope="row"
                        onClick={(event) => handleTicket(n)}
                        data-headtext=" Date created"
                      >
                        {moment(n.date_job).format('L')}
                      </TableCell> */}
                      {/* <TableCell
                        className="p-4 md:p-16"
                        component="th"
                        scope="row"
                        align="center"
                        data-headtext="Status"
                      >
                        {n.visibility ? (
                          <Icon className="text-green text-20">check_circle</Icon>
                        ) : (
                          <Icon className="text-red text-20">remove_circle</Icon>
                        )}
                      </TableCell> */}
                      <TableCell
                        className="p-4 md:p-16"
                        align="center"
                        data-headtext={t('IN_PROGRESS')}
                      >
                        <img
                          src={lockIcon}
                          alt=""
                          className={n.job_billing?.lock == true ? 'jobs-lock-icon' : 'jobs-lock-icon is-open'}
                        />
                      </TableCell>
                      <TableCell
                        className="p-4 md:p-8"
                        data-headtext={t('ACTIONS')}
                      >
                        {hasPermission('jobs.read') && (
                          <IconButton
                            className="jobs-icon-btn"
                            size="small"
                            aria-label={t('EDIT')}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClick(n);
                            }}
                          >
                            <img src={editIcon} alt="" />
                          </IconButton>
                        )}
                        <IconButton
                          className="jobs-icon-btn"
                          size="small"
                          aria-label={t('ACTIONS')}
                          onClick={(e) => {
                            e.stopPropagation();
                            setActionMenu(e.currentTarget);
                            setActionJob(n);
                          }}
                        >
                          <Icon>more_horiz</Icon>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  </ErrorBoundary>
                );
              })}
            </TableBody>
          </Table>
          {!loading && !hasNextPage ? (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1, transition: { delay: 0.1 } }}
              className="flex flex-1 items-center justify-center h-full moble-content py-64"
            >
              <Typography
                color="textSecondary"
                variant="h5"
              >
                No more Data
              </Typography>
            </motion.div>
          ) : null}
        </TableContainer>
        <div className="jobs-redesign-table-foot">
          <span>
            {t('SHOWING_VISIBLE_JOBS', {
              count: jobs.length,
              defaultValue: `Showing all ${jobs.length} visible jobs`,
            })}
          </span>
          <span className="jobs-topbar-spacer" />
          <span>
            {t('ROWS_PER_PAGE', { defaultValue: 'Rows per page' })}: {jobs.length}
          </span>
          <img src={downIcon} alt="" />
        </div>
        {loading && <LinearProgress sx={{height: '24px'}}/>}
        <Dialog
          open={openDelete}
          onClose={() => setOpenDelete(false)}
          PaperProps={{
            style: {
              backgroundColor: 'black',
              boxShadow: 'none',
            },
          }}
          classes={{
            paper: 'm-24',
          }}
          maxWidth={'md'}
        >
          <DialogContent>
            <DialogContentText
              className="flex flex-col h3 align-center justify-center items-center"
              color={'#FFFFFF'}
            >
              Are you sure you want to delete this draft.
              <Typography
                className="h3"
                color={'red'}
              >
                This action cannot be undone.
              </Typography>
            </DialogContentText>
            <br />
            <br />
            <div className="flex mx-6">
              <Button
                fullWidth
                style={{ backgroundColor: '#edca33', marginRight: '10px' }}
                onClick={() => {
                  setDeleteDraft(null);
                  setOpenDelete(false);
                }}
              >
                <Typography color={'black'}>No</Typography>
              </Button>
              <Button
                fullWidth
                style={{ backgroundColor: '#FF0000', marginLeft: '10px' }}
                onClick={handleDeleteDraft}
              >
                <Typography color={'black'}>Yes</Typography>
              </Button>
            </div>
          </DialogContent>
        </Dialog>
        <Menu
          anchorEl={actionMenu}
          open={Boolean(actionMenu)}
          onClose={closeActionMenu}
        >
          <MenuItem onClick={archiveActionJob}>
            <ListItemText primary={jobFilter == 'archived' ? 'Unarchive' : 'Archive'} />
          </MenuItem>
          {hasPermission('jobs.delete') && jobFilter == 'drafts' && (
            <MenuItem
              onClick={() => {
                setOpenDelete(true);
                setDeleteDraft(actionJob);
                closeActionMenu();
              }}
            >
              <ListItemText primary={t('DELETE')} />
            </MenuItem>
          )}
        </Menu>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    jobs: state.loadz_jobs?.JobReducer?.jobs,
    hasNextPage: state.loadz_jobs?.JobReducer?.hasNextPage,
    loading: state.loadz_jobs?.JobReducer?.loading,
    page: state.loadz_jobs?.JobReducer?.page,
    user: state.loadz_auth?.AuthReducer?.user,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getJobs: (payload, onError) => dispatch(JobAction.getJobs(payload, onError)),
  searchJobs: (payload, onError) => dispatch(JobAction.searchJobs(payload, onError)),
  logout: () => dispatch(AuthAction.logout()),
});

export default withReducer(
  'loadz_jobs',
  JobReducer
)(memo(connect(mapStateToProps, mapDispatchToProps)(JobsTable)));
